import { render, staticRenderFns } from "./ordersDeliveryPrintTable.vue?vue&type=template&id=760be342&"
import script from "./ordersDeliveryPrintTable.vue?vue&type=script&lang=ts&"
export * from "./ordersDeliveryPrintTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports